var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormPrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5H8.5L7.5 19.5H16.5L15.5 14.5Z",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 16.5H18.5C18.7652 16.5 19.0196 16.3947 19.2071 16.2071C19.3947 16.0196 19.5 15.7652 19.5 15.5V11.5H4.5V15.5C4.5 15.7652 4.60536 16.0196 4.79289 16.2071C4.98043 16.3947 5.23479 16.5 5.5 16.5H8.1",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.5H7.118C6.93226 7.49995 6.75017 7.55162 6.59215 7.64923C6.43413 7.74685 6.30642 7.88655 6.22333 8.05267L4.5 11.5H19.5L17.7767 8.05267C17.6936 7.88655 17.5659 7.74685 17.4079 7.64923C17.2498 7.55162 17.0677 7.49995 16.882 7.5H15.5",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4.5H8.5V9.5H15.5V4.5Z",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14C17.6119 14 17.5 13.8881 17.5 13.75C17.5 13.6119 17.6119 13.5 17.75 13.5",
    stroke: "#525D71",
    strokeWidth: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 14C17.8881 14 18 13.8881 18 13.75C18 13.6119 17.8881 13.5 17.75 13.5",
    stroke: "#525D71",
    strokeWidth: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5H13.5",
    stroke: "#525D71",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormPrint);
export default __webpack_public_path__ + "static/media/form-print.0ea575bda2194ec7608e509714a83a40.svg";
export { ForwardRef as ReactComponent };